import React, { useRef, useState, useEffect } from 'react';

const AudioPlayer = ({ audioSrc, nextUrl, children }) => {
  const audioRef = useRef(null);
  const progressRef = useRef(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [volume, setVolume] = useState(1);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const PlayIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" width="20" viewBox="0 0 384 512" fill="#63666A"><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"/></svg>
  );

  const PauseIcon = (
    <svg width="20" height="24" viewBox="0 0 20 24" xmlns="http://www.w3.org/2000/svg" fill="#63666A">
      <path d="M3 0C1.34375 0 0 1.34375 0 3V21C0 22.6562 1.34375 24 3 24H5C6.65625 24 8 22.6562 8 21V3C8 1.34375 6.65625 0 5 0H3ZM15 0C13.3438 0 12 1.34375 12 3V21C12 22.6562 13.3438 24 15 24H17C18.6562 24 20 22.6562 20 21V3C20 1.34375 18.6562 0 17 0H15Z" fill="#63666A"/>
    </svg>
  );
  const UnmuteIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24"  viewBox="0 0 640 512" fill="#63666A">
      <path d="M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"/>
    </svg>
  );
  const MuteIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 576 512" fill="#63666A">
      <path d="M301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/>
    </svg>
  )
  function endAudio(yerl){
    console.log ('Video End');
    
    const elements = document.getElementById("next");
    if (elements) {
      elements.disabled = false
      elements.classList.remove("disabled");
      elements.addEventListener('click', function(e) {
        window.open(yerl, "_self");
      });
    }
    
    //console.log ('Elements:'+ elements)
  }
  
 
  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      const updateProgress = () => {
        setCurrentTime(audio.currentTime);
        if (progressRef.current) {
          progressRef.current.value = (audio.currentTime / audio.duration) * 100;
        }
      };

      audio.addEventListener('timeupdate', updateProgress);
      audio.addEventListener("ended", (event) => {
        console.log("Props: "+nextUrl);
        endAudio(nextUrl);

      });
      audio.addEventListener('loadedmetadata', () => {
        setDuration(audio.duration);
      });

      return () => {
        audio.removeEventListener('timeupdate', updateProgress);
      };
    }
  }, []);

  const togglePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVolumeChange = (event) => {
    const newVolume = event.target.value;
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
    setVolume(newVolume);
    setIsMuted(newVolume === 0);
  };

  const toggleMute = () => {
    if (audioRef.current) {
      audioRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const handleProgressChange = (event) => {
    const newTime = (event.target.value / 100) * duration;
    if (audioRef.current) {
      audioRef.current.currentTime = newTime;
    }
    setCurrentTime(newTime);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div className="row mb-5">
      <div className="col-sm-12 col-md-4 audio-player">
        <div className="row">
          <audio ref={audioRef} src={audioSrc} />
          <div className="col-sm-12">
            <div className="time ta-right current">
              {formatTime(currentTime)}
            </div>
            <input
              type="range"
              min="1"
              max="100"
              step="1"
              ref={progressRef}
              onChange={handleProgressChange}
            />
            <div className="time duration">
              {formatTime(duration)}
            </div>
          </div>        
          <button onClick={togglePlayPause} className='mx-auto play-button' style={{width:"40px",height: "35px"}}>
            {isPlaying ? PauseIcon : PlayIcon}
          </button>
          <button onClick={toggleMute} className="mute-button" style={{width:"40px",height: "35px"}}>
            {isMuted ? UnmuteIcon : MuteIcon}
          </button>
        </div>
      </div>
      <div className="audio-text mt-2">
        {children}
      </div>
    </div>
  );
};

export default AudioPlayer;